module.exports = __webpack_public_path__ + "img/szycha.566a5c33.jpg";